import { STATUS, ACTION } from "./constants";

function isMapped(status) {
  return status?.toLowerCase() === STATUS.MAPPED.toLowerCase();
}

function isUnmapped(status) {
  return status?.toLowerCase() === STATUS.UNMAPPED.toLowerCase();
}

function isMappingReviewed(action) {
  return action?.toLowerCase() !== ACTION.UNDECIDED.toLowerCase();
}

function isMappingApproved(action) {
  return action?.toLowerCase() === ACTION.APPROVE.toLowerCase();
}

function isMappingRejected(action) {
  return action?.toLowerCase() === ACTION.REJECT.toLowerCase();
}

export {
  isMapped,
  isUnmapped,
  isMappingReviewed,
  isMappingApproved,
  isMappingRejected,
};
